import { render, staticRenderFns } from "./BlogSavedView.vue?vue&type=template&id=1b97ea61"
import script from "./BlogSavedView.vue?vue&type=script&lang=js"
export * from "./BlogSavedView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports